import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'Common/Components/Checkbox';

/**
 * Row selection checkbox. Presentational only: the view decides whether the row is selected
 * and what `onChange` does (select, shift ranges, dispatches…).
 */
const SelectionCell = ({ checked = undefined, onChange = undefined, disabled = undefined }) => (
  <Checkbox theme="grey" state={ checked } onChange={ onChange } disabled={ disabled } />
);

SelectionCell.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default SelectionCell;
